import { useEffect } from 'react';
import { useResizeObserver } from './useResizeObserver';
export const useResizeObserveElements = (onResize, selectors) => {
  const resizeObserver = useResizeObserver(onResize);
  useEffect(() => {
    if (!selectors.length) return;
    if (!resizeObserver) return;
    const observedElements = [];
    selectors.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) {
        resizeObserver.observe(element);
        observedElements.push(element);
      }
    });
    return () => {
      observedElements.forEach(element => {
        resizeObserver.unobserve(element);
      });
    };
  }, [selectors, onResize, resizeObserver]);
};